"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext } from "react";

// Context

export const TrackErrorContext = createContext({
  trackError: (error, context) => {
    console.error(error, context);
    return undefined;
  }
});

// Provider

export const TrackErrorProvider = t0 => {
  const $ = _c(5);
  const {
    trackError,
    children
  } = t0;
  if (!trackError) {
    return children;
  }
  let t1;
  if ($[0] !== trackError) {
    t1 = {
      trackError
    };
    $[0] = trackError;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <TrackErrorContext.Provider value={t1}>{children}</TrackErrorContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};